import create, { SetState } from 'zustand';

import { ToastState, ToastType } from './types';

export const useToastStore = create<ToastState>((set: SetState<ToastState>) => {
  function toast(title: string, message: string, type?: ToastType) {
    set((state: ToastState) => {
      return { ...state, isOpen: true, title, message, type };
    });
  }

  function dismiss() {
    set((state: ToastState) => {
      return { ...state, isOpen: false, message: `` };
    });
  }
  return {
    isOpen: false,
    title: ``,
    message: ``,
    type: undefined,
    toast,
    dismiss,
  };
});
